const RECENT_PRODUCTS_KEY = "recentViewedProducts";
const MAX_RECENT_PRODUCTS = 8;

const canUseStorage = () =>
  typeof window !== "undefined" && typeof window.localStorage !== "undefined";

const recentKey = (product) =>
  String(product?._id || product?.id || product?.name || "").trim().toLowerCase();

export const compactRecentProduct = (product) => ({
  _id: product?._id || product?.id || "",
  name: product?.name || "",
  image: product?.image || "",
  category: product?.category || "",
  tag: product?.tag || "",
  stock: product?.stock || "yes",
});

export const readRecentProducts = () => {
  if (!canUseStorage()) return [];

  try {
    const raw = window.localStorage.getItem(RECENT_PRODUCTS_KEY);
    const parsed = JSON.parse(raw || "[]");
    if (!Array.isArray(parsed)) return [];

    return parsed
      .map(compactRecentProduct)
      .filter((product) => recentKey(product))
      .slice(0, MAX_RECENT_PRODUCTS);
  } catch {
    return [];
  }
};

const writeRecentProducts = (products) => {
  if (!canUseStorage()) return products;
  window.localStorage.setItem(
    RECENT_PRODUCTS_KEY,
    JSON.stringify(products.slice(0, MAX_RECENT_PRODUCTS))
  );
  return products;
};

export const saveRecentProduct = (product) => {
  const item = compactRecentProduct(product);
  const key = recentKey(item);
  if (!key) return readRecentProducts();

  const existing = readRecentProducts();
  const next = [
    item,
    ...existing.filter((saved) => recentKey(saved) !== key),
  ].slice(0, MAX_RECENT_PRODUCTS);

  return writeRecentProducts(next);
};

export const clearRecentProducts = () => {
  if (canUseStorage()) {
    window.localStorage.removeItem(RECENT_PRODUCTS_KEY);
  }
  return [];
};

export const enrichRecentProducts = (recentProducts, products) => {
  const liveProducts = Array.isArray(products) ? products : [];
  const byId = new Map();
  const byName = new Map();

  liveProducts.forEach((product) => {
    const compact = compactRecentProduct(product);
    if (compact._id) byId.set(String(compact._id), compact);
    if (compact.name) byName.set(String(compact.name).toLowerCase(), compact);
  });

  return (Array.isArray(recentProducts) ? recentProducts : [])
    .map((saved) => {
      const compact = compactRecentProduct(saved);
      const match =
        byId.get(String(compact._id)) ||
        byName.get(String(compact.name).toLowerCase());

      return match || compact;
    })
    .filter((product) => recentKey(product))
    .slice(0, MAX_RECENT_PRODUCTS);
};
